import $ from 'jquery';
import React from "react";
import ReactDOM from "react-dom";
import uuid from "uuid";
import ActionTypes from "./../../actionTypes";
import KeyboardKey from "./keyboardKey";
import Config from "./../../config";
import * as Misc from "./../../misc";
import Analytics from './../../analytics';

export default class OnScreenKeyboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: '',
      hidden: true,
      selectionStart: 0,
      selectionEnd: 0,
      type: this.props.type || "standard",
      oskInputId: uuid.v4(),
      isUpperCase: false,
      osk: document.kvConfig.osk,
      parentNode: null
    };
  };

  componentDidMount() {
    $(this.refs.osk_overlay).detach().appendTo(".main-wrapper");

    this.tryBindToParent();
    this.setState({parentNode: $(this.refs.osk_overlay).parent()});

    const self = $(ReactDOM.findDOMNode(this));
    const lightbox = self.parents('.lightbox-options-wrapper');
    if (lightbox) {
      lightbox.on('scroll', this.setKBPosition.bind(this, self, lightbox));
      this.setKBPosition(self, lightbox);
    }

    $(document).on(ActionTypes.SHOW_NUMERIC_KBD, this.handleShowKeyboard);
    $(document).on(ActionTypes.OVERLAY_CLICK, this.handleShowKeyboard);
    $(document).on('click', this.handleOutsideClick);
  }

  componentDidUpdate() {
    this.tryBindToParent();
    const fields = this.getFields();
    if (!this.state.hidden) {
      const selStart = this.state.selectionStart,
        selEnd = this.state.selectionEnd;
      if (fields.input) {
        fields.input.value = this.passwordify(this.state.value);
        fields.$input.focus();
        fields.input.setSelectionRange(selStart, selEnd);
      }
    }
  }

  componentWillReceiveProps(nextProps) {  // we need to update this state when parent passes new value
      nextProps.value && nextProps.value !== this.state.value && this.setState({
          value: nextProps.value
      });
  }

  componentWillUnmount = () => {
    $(this.refs.osk_overlay).detach().appendTo(this.state.parentNode);
    $('.lightbox-options-wrapper').off('scroll');
    $(document).off(ActionTypes.SHOW_NUMERIC_KBD, this.handleShowKeyboard);
    $(document).off(ActionTypes.OVERLAY_CLICK, this.handleShowKeyboard);
    $(document).off('click', this.handleOutsideClick);
  };

  getFields = () => {
    const $parent = $('#' + (this.props.inputId ? this.props.inputId : this.props.parentId)),
      $parentInput = (this.props.inputId ? $('#' + this.props.inputId) : $parent.find('input[type=text]:not(".osk-input")')),
      parentInput = $parent[0],
      $input = $('#' + this.state.oskInputId),
      input = $input[0];
    return {
      $input: $input,
      input: input,
      $parent: $parent,
      $parentInput: $parentInput,
      parentInput: parentInput
    };
  };

  tryBindToParent = () => {
    if (!this.state.osk) {
      return;
    }

    let fields = this.getFields();
    if (!fields || !fields.parentInput || fields.parentInput === undefined) {
      console.log('could not bind, fields is null');
      return;
    }

    //console.log('bound to parent', this.props.inputId, fields.$parentInput, fields.parentInput);
    $(fields.parentInput).off('focus').on('focus', this.show);
    $(fields.parentInput).off('click').on('click', function (e) {
      Misc.ignoreDefault(e);
    });
  };

  setKBPosition = (self, lightbox) => {
    if (lightbox.is(":visible")) {
      const parent = self.parent();
      const offset = parent.offset();
      self.css({
        top: offset.top + 60,
        left: offset.left + 50,
        position: 'fixed'
      });
    }
  };

  handleShowKeyboard = (e, data) => {
    if (this.state.hidden) {
      return;
    }

    if (!data || data.sender !== this.state.oskInputId) {
      this.hide();
    }
  };

  show = (e) => {
    Misc.ignoreDefault(e);
    const fields = this.getFields(),
      val = fields.$parentInput.val();
    //console.log('Show', fields);

    $(document).trigger(ActionTypes.SHOW_NUMERIC_KBD, {sender: this.state.oskInputId});
    this.setState({value: val, hidden: false, selectionStart: val.length, selectionEnd: val.length, blockOutsideClick: true});
    window.setTimeout(() => {
      this.setState({blockOutsideClick: false});
    }, 500);
  };

  
  handleOutsideClick = (e) => {
    if(this.state.blockOutsideClick) {
      return;
    }
    if($(e.target).parents('.keyboard-container').length <= 0) {
      this.hide();
    }
  };

  hide = () => {
    this.setState({hidden: true});
    setTimeout(() => {
      document.inputFocused = false;
    }, 20);
  };
  passwordify = (value) => {
    if (this.props.password) {
      for (let i = 0; i < value.length - 1; i++) {
        value = value.substring(0, i) + '*' + value.substring(i + 1);
      }
    }
    return value;
  };

  changeValue = (e) => {
    this.setState({value: e.target.value});
  };

  runKeyStroke = (key) => {
    document.inputFocused = true;
    if (key && key.length > 0) {
      const fields = this.getFields();
      let val = this.state.value,
        start = val,
        end = "",
        input = fields.parentInput,
        $input = fields.$input,
        $parentInput = fields.$parentInput,
        selStart = input.selectionStart,
        selEnd = input.selectionEnd;
      //const ss = input.selectionStart, se = input.selectionEnd;
      // if (ss && ss !== selStart) {
      //   selStart = ss;
      // }
      // if (se && se !== selEnd) {
      //   selEnd = se;
      // }
      //console.log('>>', selStart, selEnd, key);
      if (selStart < val.length) {
        start = val.substring(0, selStart);
        end = val.substring(selEnd);
      }
      let inc = key.length;
      switch (key.toLowerCase()) {
        case "backspace":
          inc = -1;
          if (selStart < val.length) {
            if (selStart === selEnd) {
              start = start.substring(0, start.length - 1);
            } else {
              inc = 0;
              selEnd = selStart;
            }
            val = start + end;
          } else if (val.length > 0) {
            val = val.substring(0, val.length - 1);
          }
          break;
        case '|<':
        case '|>':
          if (key === '|<') {
            inc = -1;
          } else {
            if (selStart < selEnd) {
              inc = 0;
              selStart = selEnd;
            } else {
              inc = 1;
            }
          }
          break;
        case "space bar":
        case "space":
          val = start + " " + end;
          break;
        case "caps":
        case "shift":
          this.setState({isUpperCase: !this.state.isUpperCase});
          break;
        default:
          if (!this.state.isUpperCase) {
            key = key.toLowerCase();
          } else {
            key = key.toUpperCase();
          }
          val = start + key + end;
          selStart = start.length;
          selEnd = selStart;
          break;
      }
      //console.log('\t>> ', selStart, selEnd, val, val.length, inc);
      if (selStart + inc > val.length) {
        selStart = val.length;
        selEnd = val.length;
      } else {
        selStart += inc;
        if (selEnd + inc > val.length) {
          selEnd = val.length;
        } else {
          selEnd += inc;
        }
      }
      if (selStart < 0) {
        selStart = 0;
      }
      if (selEnd < selStart) {
        selEnd = selStart;
      }

      this.setState({value: val, select: false}, () => {
        input.setSelectionRange(selStart, selEnd);
        if($input.length > 0)
          $input.focus();
        else
          $parentInput.focus();
      });
      // if ($input) {
      //   console.log('\t\t>>', selStart, selEnd);
      //   input.setSelectionRange(selStart, selEnd);
      //   $input.val(val);
      //   $input.focus();
      // }

      this.setParentValue(val);
    }
  };
  setParentValue = (value) => {
    Analytics.sendDataEnteredEvent('osk-update-parent-textbox');
    //console.log('setValue', value, this.props);
    if (this.props.setValue) {
      if (this.props.prop) {
        this.props.setValue(this.props.prop, value);
      } else {
        this.props.setValue(value);
      }
    }
  };

  done = () => {
    this.setParentValue(this.state.value);
    this.hide();
  };

  mouseUp = () => {
    const fields = this.getFields();
    this.setState({
      selectionStart: fields.input.selectionStart,
      selectionEnd: fields.input.selectionEnd
    });
  };

  render() {
    const visible = {
      display: this.state.hidden ? "none" : "block",
      transition: "all 0.5s ease-in-out",
      top: this.props.top,
      left: this.props.left
    };
    if (this.props.type === "numeric") {
      return this.renderNumericKeyboard(visible);
    }

    const arrowKeys = {
      left: (Config.kioskStandAlone || location.port === '9007' ? '.' : '/Content/Views/quickquote-v3') + '/images/buttons/KeyboardLeftArrow.svg',
      right: (Config.kioskStandAlone || location.port === '9007' ? '.' : '/Content/Views/quickquote-v3') + '/images/buttons/KeyboardRightArrow.svg'
    };

    const mainFrameClass = "keyboard-container " + (this.props.type === 'email' ? 'keyboard-main-frame-extended' : 'keyboard-main-frame');

    return (
      <div className={mainFrameClass} style={visible} ref="mainFrame">
        <div className="keyboard-header-bar-close-button" onClick={this.hide}/>
        <div className="keyboard-header-bar">Drag to Move</div>
        <div className="keyboard-panel-wrapper">
          <div className="keyboard-left-panel">
            <KeyboardKey type="NORMAL" keyValue2="!" keyValue="1" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="@" keyValue="2" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="#" keyValue="3" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="$" keyValue="4" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="%" keyValue="5" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="^" keyValue="6" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="&" keyValue="7" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="*" keyValue="8" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="(" keyValue="9" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2=")" keyValue="0" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="backspace" runKeyStroke={this.runKeyStroke}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="Q" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="W" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="E" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="R" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="T" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="Y" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="U" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="I" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="O" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2="" keyValue="P" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='"' keyValue="'" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="A" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="S" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="D" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="F" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="G" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="H" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="J" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="K" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="L" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='{' keyValue="[" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='}' keyValue="]" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="Z" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="X" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="C" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="V" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="B" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="N" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='' keyValue="M" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='-' keyValue="," runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='_' keyValue="." runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2='?' keyValue="/" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL" keyValue2=':' keyValue=";" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase}/>
            <KeyboardKey type="NORMAL_3" keyValue2='' keyValue="Shift" runKeyStroke={this.runKeyStroke}
                         isUpperCase={this.state.isUpperCase} raw={true}/>
            <KeyboardKey type="NORMAL_5" keyValue2='' keyValue="Space" runKeyStroke={this.runKeyStroke} raw={true}/>
            <KeyboardKey type="NORMAL_2_5" keyValue2='' keyValue="|<" image={arrowKeys.left}
                         runKeyStroke={this.runKeyStroke}/>
            <KeyboardKey type="NORMAL_2_5" keyValue2='' keyValue="|>" image={arrowKeys.right}
                         runKeyStroke={this.runKeyStroke}/>
          </div>
          {this.renderEmailPanel()}
        </div>
      </div>
    );
  }

  renderEmailPanel = () => {
    if (this.props.type !== 'email') {
      return null;
    }

    return (
      <div className="keyboard-right-panel">
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@gmail.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>@gmail.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@yahoo.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>@yahoo.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@hotmail.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL" isUpperCase={this.state.isUpperCase}>@hotmail.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@gmail.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>@aol.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@msn.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>@msn.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@me.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>@me.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue="@icloud.com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL" isUpperCase={this.state.isUpperCase}>@icloud.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue=".com"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>.com</KeyboardKey>
        <KeyboardKey className="keybard-right-panel-buttons" keyValue=".net"
                     runKeyStroke={this.runKeyStroke} type="RIGHT_PANEL"
                     isUpperCase={this.state.isUpperCase}>.net</KeyboardKey>
      </div>
    );
  };

  renderNumericKeyboard = (visible) => {
    //<div className="exclude-children-from-overflow">
    return (

      <div className="keyboard-container numberpad-main-frame" style={visible}>
        <div className="help-balloon-pointer"/>
        <div className="help-balloon-close-button" onClick={this.hide}/>
        <KeyboardKey type="BACKSPACE" keyValue="backspace" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="7" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="8" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="9" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="4" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="5" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="6" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="1" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="2" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="3" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC_EXTENDED" keyValue="0" runKeyStroke={this.runKeyStroke}/>
        <KeyboardKey type="NUMERIC" keyValue="." runKeyStroke={this.runKeyStroke}/>
      </div>

    );
    //</div>
  }
};



// WEBPACK FOOTER //
// ./src/components/OnScreenKeyboard/keyboard.js